export const HOME_PATH = '/';
export const CHALLENGE_PATH = '/challenge';
export const STATS_PATH = '/stats';
export const HELP_PATH = '/help';
export const SETTINGS_PATH = '/settings';
